import { useContext } from "react";
import { AngelChatContext } from "../providers/angel-chat-provider";

const UseAngelChat = () => {
  const chat = useContext(AngelChatContext);

  return chat;
};

export default UseAngelChat;
